import React, { useEffect, useState } from 'react';
import { CircularProgress, Alert } from '@mui/material';
import axios from 'axios';
import baseURL from '../../config';
import SubscriptionForm from './VesselOwnerSubscriptionForm.jsx';
import VesselOwnerSubscriptionDetails from "./VesselOwnerSubscriptionDetails.jsx"

const SubscriptionWrapper = () => {
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSubscription = async () => {
      const vesselOwnerId = localStorage.getItem('urlID');

      if (!vesselOwnerId) {
        setError('Vessel Owner ID not found in local storage.');
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get(
          `${baseURL}/api/vesselowner-subscription/getSubscriptionDetails/${vesselOwnerId}`
        );

        setSubscription(res.data);
      } catch (err) {
        // If 404 or no subscription, do nothing (let subscription remain null)
        if (err.response?.status !== 404) {
          setError('Failed to fetch subscription data.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, []);

  if (loading) return <CircularProgress sx={{ mt: 4 }} />;

  if (error) return <Alert severity="error">{error}</Alert>;

  return subscription ? (
    <VesselOwnerSubscriptionDetails subscriptionData={subscription} />
  ) : (
    <SubscriptionForm />
  );
};

export default SubscriptionWrapper;
